module.exports = __webpack_public_path__ + "static/media/abhishek.2121da5b.png";